export const SCROLLERS = [".tg-day-scroll", ".tg-week-scroll"];

export function captureScroll(root, win) {
  const boxes = SCROLLERS.flatMap((selector) => {
    const box = root.querySelector(selector);
    return box ? [{ selector, left: box.scrollLeft, top: box.scrollTop }] : [];
  });
  return { boxes, x: win.scrollX, y: win.scrollY };
}

export function restoreScroll(root, win, state) {
  if (!state) return false;
  state.boxes.forEach(({ selector, left, top }) => {
    const box = root.querySelector(selector);
    if (!box) return;
    box.scrollLeft = left;
    box.scrollTop = top;
  });
  if (win.scrollX !== state.x || win.scrollY !== state.y) win.scrollTo(state.x, state.y);
  return true;
}
